<template>
  <div>
    <div class="row">
     <div class="input-field col s12 m6 l6 xl6">
          <input id="nome" name="nome" required type="text" 
          class="validate" v-model='cen.nome'>
          <label for="nome">Nome </label>
      </div>
      <div class="input-field col s12 m6 l6 xl6">
          <input id="sigla" name="sigla" required type="text" class="validate" 
          v-model='cen.sigla'>
          <label for="sigla">Sigla</label>
      </div>
       <div class="input-field col s6 m6 l3 xl3">
        <button  type="submit" class="btn">
          <i v-if="!cen.id" class="material-icons left">
            save
          </i>
            
          <i v-else class="material-icons left "> 
            edit
          </i>
          <span v-if="!cen.id">
            Salvar
          </span>
          <span v-else>
            Atualizar
          </span>
        </button>
      </div>
     <div class="input-field col s6 m6 l3 xl3">
        <button  type="reset" class="btn indigo" @click="clear">
          <i class="material-icons right">clear</i>
          Limpar</button>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      name: "VueCentroForm",
      props: [
        'centro'
      ],
      data () {
        return {
          cen: JSON.parse(this.centro),
          info: '',
          nomeLength: false,
          nomeGuard: '',
          sigla:'',
        }
      },
      computed: {
       centroId() {
          return this.cen.id;
       }
      },
      methods: {
        verifyNome () {
          this.verifyNomeLength()
        },
        clear (ev, nomeInput = '') {
          this.cen = {
            sigla:'',
            nome: nomeInput,
            id: null,
          }
        },
        verifyNomeLength() {
          if (this.cen.nome.length <= 100)
            this.nomeLength = true
          else
            this.nomeLength = false
        },
      },
      ready () {
      }
    }

</script>
